module.exports = __webpack_public_path__ + "static/media/UnitedSansReg-Medium.a1fea40d.ttf";